import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
export var DialogInner = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  min-width: 220px;\n"])));